import React from 'react'
import AsyncSelect from 'react-select/async'
import debounce from 'debounce-promise'
import DateTime from 'react-datetime'
import {FormattedMessage, useIntl} from "react-intl";
import messages from "./messages";

const Distribution = ({ state: { countries, start, comments, distribution_comments }, setState }) => {
  const { formatMessage } = useIntl()
  const loadCountries = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch(`/rest/v2/country?search[name]=${query}&search[hidden]=0&search[deleted]=0`)
        .then(response => response.json())
        .then((countries) => {
          resolve(countries.map(({ uid, name }) => ({ value: uid, label: name })))
        })
        .catch(reject)
    })
  }, 250)

  return (
    <div className="mt-4">
      <div>
        <div className="text-gray-500 mb-2">Distribution countries</div>
        <AsyncSelect
          value={countries}
          onChange={(countries) => setState((state) => ({ ...state, countries }))}
          isMulti
          cacheOptions
          loadOptions={loadCountries}
          openMenuOnFocus
          noOptionsMessage={({ inputValue }) => `${formatMessage(messages.noOptions)} '${inputValue}'`}
          loadingMessage={({ inputValue }) => `${formatMessage(messages.searching)} '${inputValue}'..`}
          placeholder={formatMessage(messages.countries)}
        />
      </div>
      <div className="flex mt-3">
        <div className="grow">
          <div className="text-gray-500 mb-2">Distribution comments</div>
          <textarea
            type="text"
            className="rounded-sm border border-gray-400 px-4 py-3 w-full h-32"
            value={distribution_comments}
            onChange={({ target }) => setState((state) => ({ ...state, distribution_comments: target.value }))}
          />
        </div>
        <div className="w-40 ml-3">
          <div className="text-gray-500 mb-2">From Date</div>
          <DateTime
            value={start}
            onChange={(start) => setState((state) => ({ ...state, start }))}
            className="rounded-sm border border-gray-400 px-4 py-3"
            closeOnTab
            closeOnSelect
            timeFormat={false}
          />
        </div>
      </div>
    </div>
  )
}

export default Distribution
